var _circle, _circle2, _g, _g2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.933 2.933 58.133 58.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 21,
    fill: "none",
    stroke: "#2b2f63",
    strokeWidth: 2.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 17,
    fill: "none",
    stroke: "#9aa0c8",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2b2f63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2 L36 28 L32 32Z M32 62 L28 36 L32 32Z M2 32 L28 28 L32 32Z M62 32 L36 36 L32 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14 L31 30 L29 32Z M50 50 L33 34 L35 32Z M50 14 L34 31 L32 29Z M14 50 L30 33 L32 35Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#8e95c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2 L28 28 L32 32Z M32 62 L36 36 L32 32Z M2 32 L28 36 L32 32Z M62 32 L36 28 L32 32Z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 2.5,
    fill: "#fff",
    stroke: "#2b2f63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploration);
export default __webpack_public_path__ + "static/media/exploration.e54acdb1939d8e4b18341afe00158e05.svg";
export { ForwardRef as ReactComponent };